export function sanitizeAdminUser (value) {
  let user = value
  if (typeof user === 'string') {
    try {
      user = JSON.parse(user)
    } catch (error) {
      return null
    }
  }
  if (!user || typeof user !== 'object' || Array.isArray(user)) {
    return null
  }
  const sanitized = Object.assign({}, user)
  delete sanitized.password
  return sanitized
}

export function persistAdminUser (storage, key, value) {
  const sanitized = sanitizeAdminUser(value)
  if (!sanitized) {
    storage.removeItem(key)
    return null
  }
  storage.setItem(key, JSON.stringify(sanitized))
  return sanitized
}



// WEBPACK FOOTER //
// ./src/assets/utils/adminUserStorage.js